import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-list-datas',
  templateUrl: './list-datas.component.html',
  styleUrls: ['./list-datas.component.css']
})
export class ListDatasComponent implements OnInit {
    public listKeyno;

    public itemsListDatas: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.listKeyno = this.stateService.getStateParams()['list_keyno'];
    }

    private async loadListDatas() {
        if (!!this.listKeyno) {
            this.itemsListDatas = await this.datatask.Post(2718, { list_keyno: this.listKeyno });
        }
    }

    private async init() {
        this.loadListDatas();
    }

    ngOnInit() {
        this.init();
    }
}
